export const orgLicencing = (orgs: any, licensingData: any): any => {
  // Read at call time (not module load) so build-time env injection still
  // works — webpack's DefinePlugin inlines this reference wherever it
  // appears — while remaining testable without a module reset.
  const trialingPlanId = process.env.REACT_APP_TRIALING_APP_ID;
  const orgLicencingMap: any = {};
  licensingData?.forEach((data: any) => {
    data?.contracts?.forEach((contract: any) => {
      if (contract?.app_id === trialingPlanId) {
        orgLicencingMap[contract.workspace_id] = true;
      } else if (orgLicencingMap[contract.workspace_id] !== true) {
        orgLicencingMap[contract?.workspace_id] = false;
      }
    });
  });
  return orgLicencingMap;
};

export const applyOrgLiecningToOrgs = (
  orgs: any,
  licencingStatus: any
): any => {
  if (Array.isArray(orgs?.content)) {
    return {
      content: orgs.content.map((org: any) => ({
        ...org,
        hasAccess: Boolean(licencingStatus?.[org.workspace_id]),
      })),
    };
  }
  return { content: [] };
};
